import React, { useRef } from 'react';
import { Circle, Tooltip } from 'react-leaflet';

export default function PointMarker(props) {
  const {
    center, text,
  } = props;
  const markerRef = useRef(null);

  return (
    <Circle
      center={center}
      radius={10}
      fillColor="#ff0000"
      color="#ff0000"
      eventHandlers={{
        mouseover: () => markerRef.current?.openPopup(),
        mouseout: () => markerRef.current?.closePopup(),
      }}
    >
      <Tooltip direction="left" offset={[10, -10]} opacity={1}>{text}</Tooltip>
    </Circle>
  );
}
